import { MILLISECONDS_PER_SECOND } from 'constants/date';
import { isDebugMode } from 'utils/debug';

let cachedUrl = window.location.href;

export const pingForUrlChange = (
  intervalRef: NodeJS.Timeout | undefined,
  onChangeCallback: () => void,
  intervalMs = MILLISECONDS_PER_SECOND,
) => {
  clearInterval(intervalRef);

  let elapsedMs = 0;
  return setInterval(() => {
    const latestUrl = window.location.href;
    if (isDebugMode()) {
      console.log({ elapsedMs, latestUrl, cachedUrl });
    }
    if (cachedUrl !== latestUrl) {
      if (isDebugMode()) {
        console.log('In pingForUrlChange. URL change identified', { cachedUrl, latestUrl });
      }
      onChangeCallback();
      cachedUrl = latestUrl;
      clearInterval(intervalRef);
    }
    elapsedMs += intervalMs;
  }, intervalMs);
};
